import { API } from '~apis/axios/instance';
import { ResponseBase } from '~types/response';

export interface CalculatorFormData {
  userName: string;
  companyName: string;
  userPosition: string;
  email: string;
  monthlyAverageRevenue: number;
  monthlyAverageSpend: number;
  cashAtHand: number;
  agreeToPersonalInfoCollection: boolean;
}

export const isPayoutEstimationCode = (code?: string): code is PayoutEstimationCode => {
  return (
    code === 'SUCCESS' ||
    code === 'UNDER_YEARLY_REVENUE_THRESHOLD' ||
    code === 'UNDER_MINIMUM_PAYOUT_ESTIMATION'
  );
};

export type PayoutEstimationCode =
  | 'SUCCESS'
  | 'UNDER_YEARLY_REVENUE_THRESHOLD'
  | 'UNDER_MINIMUM_PAYOUT_ESTIMATION';

export interface PayoutEstimationSuccessResponse extends ResponseBase {
  code: 'SUCCESS';
  data: {
    id: number;
    tradingPeriod: number;
    maxPayoutLimit: number;
    minPayoutLimit: number;
  };
}

export interface PayoutEstimationUnderYearlyRevenueResponse extends ResponseBase {
  code: 'UNDER_YEARLY_REVENUE_THRESHOLD';
  data: {
    id: number;
    maxPayoutLimit: null;
    minPayoutLimit: null;
  };
}

export interface PayoutEstimationUnderUnderMinimumPayoutEstimationResponse extends ResponseBase {
  code: 'UNDER_MINIMUM_PAYOUT_ESTIMATION';
  data: {
    id: number;
    maxPayoutLimit: number;
    minPayoutLimit: null;
  };
}

export type PayoutEstimationResponse =
  | PayoutEstimationSuccessResponse
  | PayoutEstimationUnderYearlyRevenueResponse
  | PayoutEstimationUnderUnderMinimumPayoutEstimationResponse;

export const payoutEstimate = (data: CalculatorFormData) => {
  return API.post<PayoutEstimationResponse>(
    `/api/v2/payout-estimations`,
    {
      data,
    },
    true,
  );
};
